import { UntitledIcon } from '@faceup/icons'
import { ulArrowLeft } from '@faceup/icons/ulArrowLeft'
import { defineMessages, useIntl } from '@faceup/localization'
import { Button } from '@faceup/ui-base'
import { type FragmentType, getFragmentData, graphql } from '../../../../../../__generated__'
import { useClient } from '../../../../../../App/ClientProvider'

import { LanguageDropdown } from '../../../../../LanguageDropdown/LanguageDropdown'
import { LogoutButton } from '../../../../../LogoutButton'
import { PartnerInstitutionLogo } from '../PartnerInstitutionLogo'
import { PagesMenu } from './components/PagesMenu'

const messages = defineMessages(
  'followUp.components.institutionLayout.components.header.components.headerComplexWithPages',
  [
    { id: 'openMenu', defaultMessage: 'Open menu' },
    { id: 'closeMenu', defaultMessage: 'Close menu' },
  ] as const
)

const fragments = {
  HeaderComplexWithPages_reportSource: graphql(`
    fragment HeaderComplexWithPages_reportSource on PublicReportSource {
      id
      languages
      defaultLanguage

      ...PartnerInstitutionLogo_reportSource
      ...PagesMenu_reportSource
    }
  `),
}

type HeaderComplexWithPagesProps = {
  reportSource: FragmentType<typeof fragments.HeaderComplexWithPages_reportSource>
  isMenuOpened: boolean
  setIsMenuOpened: (isOpened: boolean) => void
}

export const HeaderComplexWithPages = ({
  isMenuOpened,
  setIsMenuOpened,
  reportSource: _reportSource,
}: HeaderComplexWithPagesProps) => {
  const reportSource = getFragmentData(fragments.HeaderComplexWithPages_reportSource, _reportSource)
  const { client } = useClient()
  const { formatMessage } = useIntl()
  const isApp = client === 'app'

  return (
    <div className='flex h-full w-full items-center'>
      <div className='flex max-h-full min-w-0 flex-grow basis-0 items-center justify-start overflow-hidden'>
        <PartnerInstitutionLogo reportSource={reportSource} />
      </div>
      <div className='mx-16 hidden min-w-0 flex-grow-[2] basis-0 justify-center overflow-hidden sm:flex'>
        <PagesMenu reportSource={reportSource} />
      </div>
      <div className='hidden min-w-0 flex-grow basis-0 items-center justify-end sm:flex'>
        {reportSource.languages.length > 1 && (
          <LanguageDropdown
            availableLanguages={reportSource.languages}
            defaultLanguage={reportSource.defaultLanguage}
          />
        )}
        {isApp && <LogoutButton />}
        <div className='sm:hidden'>
          <Button
            type='text'
            icon={<UntitledIcon icon={ulArrowLeft} size={24} />}
            label={formatMessage(isMenuOpened ? messages.closeMenu : messages.openMenu)}
            onClick={() => setIsMenuOpened(!isMenuOpened)}
          />
        </div>
      </div>
    </div>
  )
}
